import React from "react";

export default function ExpandedAccordionRow({
  title,
  courseId,
  idx,
  courseProp,
}) {
  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <h4 className="panel-title">
          <a
            className="accordion-toggle"
            data-toggle="collapse"
            data-parent="#accordion"
            href={"#" + courseId + idx}
          >
            {title}
          </a>
        </h4>
      </div>
      <div id={courseId + idx} className="panel-collapse collapse">
        <div className="panel-body">
          <p
            className="textLeft"
            dangerouslySetInnerHTML={{ __html: courseProp }}
          />
        </div>
      </div>
    </div>
  );
}
